import { connect } from 'react-redux';

import { actions } from '../../../state/filterActions';
import { fetchHotelResults } from '../../../state/hotelResultActions';

import type { PaleState } from '../../../interfaces';
import { TravelTimePicker, type TravelTimePickerProps } from './TravelTimePicker';

const mapStateToProps = (
    state: PaleState,
): Pick<TravelTimePickerProps, 'travelMonths' | 'duration' | 'travelMonthsClassName' | 'horizontal'> => ({
    travelMonths: state.filters.travelMonths,
    duration: state.filters.duration,
    travelMonthsClassName: 'u-mb16 u-r-size1of2',
    horizontal: true,
});

const mapDispatchToProps = {
    setIgnoredFilters: actions.setIgnoredFilters,
    triggerFetch: fetchHotelResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(TravelTimePicker);
